import React from 'react'
import styled from 'styled-components'
import { mote_primary } from '@mote/config/defaults/colors'
import { Block, Button, H3, P, Spinner } from '@mote/ui'
import { Card } from './Card'

export const MessageCard = ({
  title,
  message,
  icon,
  ctaProps,
  loading = false,
  showTextOnLoading = false,
  ...rest
}) => {
  return (
    <Root gap={32} spreadX {...rest}>
      {(!loading || (loading && showTextOnLoading)) && (
        <>
          <Block align='center' justify='center' gap={32}>
            {icon && (
              <P fontSize={48} lineHeight='100%' alignment='center'>
                {icon}
              </P>
            )}
            <Block
              align='center'
              justify='center'
              gap={loading && showTextOnLoading ? 32 : 24}
            >
              <H3
                fontSize={24}
                fontWeight={700}
                lineHeight='120%'
                color='#25252D'
                alignment='center'
              >
                {title}
              </H3>

              {loading && showTextOnLoading && (
                <Spinner radius={90} color={mote_primary} />
              )}

              <P
                fontSize={15}
                fontWeight={400}
                lineHeight='140%'
                color='#6C6C84'
                alignment='center'
                styles={{ maxWidth: '525px' }}
              >
                {message}
              </P>
            </Block>
          </Block>

          {ctaProps && <Button {...ctaProps} />}
        </>
      )}

      {loading && !showTextOnLoading && (
        <Block align='center' justify='center'>
          <Spinner radius={90} color={mote_primary} />
        </Block>
      )}
    </Root>
  )
}

const Root = styled(Card)`
  margin-top: 40px;
  min-height: 385px;

  @media (max-width: 639px) {
    margin-top: 24px;
    min-height: 100%;
  }
`
